export default __webpack_public_path__ + "static/media/DSC_0528.88b5272d.webp";